import axios from "axios"

// export const updateLoadPost = (load_post_id, data) => {
//     return axios({
//       method: 'patch',
//       url: `/api/load_postings/${load_post_id}`,
//       data: data
//     })
// }

export const updateLoadPost = (data) => {
  return axios({
    method: 'post',
    url: `/api/load_postings/patch_multiple_posts`,
    data: data
  })
}

//Not sure why the rest are in load and this one is in load postings, but ok
export const  updateLoadPostRates = (load_id, rate) => {
  const params = {
    action: 'refresh_rates'
  }

  return axios({
    method: 'post',
    url: '/api/v2/load_postings',
    params,
    data: {
      load_id,
      rate
    }
  })
}